import Vue from 'vue';
import dayjs from 'dayjs';

import VueClipboard from 'vue-clipboard2';
import Validator from 'async-validator';
import vueSwiper from 'vue-awesome-swiper';
import vueHandMobile from 'vue-hand-mobile';

import { Toast, ActionSheet, Lazyload } from 'vant';
import 'vue2-animate/dist/vue2-animate.min.css';
import 'swiper/dist/css/swiper.css';

import '@/styles/main.scss';
import icons from '@/icons';
import Components from '@/components';
import Mixins from './mixins';
import App from './App.vue';
import router from './router';
import store from './store';
import http from './api/http';
import request from './api/http/request';
import burialPoint from './utils/burialPoint';

if (window.VConsole) {
  const vConsole = new window.VConsole({ maxLogNumber: 1000 });
  console.log(vConsole);
}

// 自动播放的音乐对象
window.audio = new Audio();
window.audio.loop = true;
window.audio.autoplay = true;

document.addEventListener(
  'WeixinJSBridgeReady',
  function () {
    // const src = `https://oss-cfmoto.zeehoev.com/uploads/cfmoto-h5/music/%E9%85%8D%E4%B9%90.mp3?t=${new Date().getTime()}`;
    // window.audio.src = src;
    console.log('WeixinJSBridgeReady');
    window.audio.play();
  },
  false
);

http.Toast = Toast;

// Vue.prototype.$audio = window.audio;
Vue.prototype.$dayjs = dayjs;
Vue.prototype.toast = Toast;
Vue.prototype.axios = request;
Vue.prototype.$Validator = Validator;
Vue.prototype.$burialPoint = burialPoint;

window.app = Vue;
Vue.use(vueHandMobile);
Vue.use(VueClipboard);
Vue.use(icons);
Vue.use(Components);
Vue.use(Lazyload);
Vue.use(Mixins);
Vue.use(vueSwiper);
Vue.use(Toast);
Vue.use(ActionSheet);
Vue.config.productionTip = false;

// alert(navigator.userAgent);
// alert(Vue.isApp);
// alert(window.location.hash);
if ((Vue.isMiniapp || Vue.isApp) && !/token=[\w_-]+/.test(window.location.hash)) {
  localStorage.removeItem('token');
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});

window.app = Vue;
/* eslint-disable */
Date.prototype.format = function format(fmt) { // author: meizz
  const o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, // 小时
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  const week = {
    0: '/u65e5',
    1: '/u4e00',
    2: '/u4e8c',
    3: '/u4e09',
    4: '/u56db',
    5: '/u4e94',
    6: '/u516d',
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${this.getFullYear()}`).substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') + week[`${this.getDay()}`]);
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)));
    }
  }
  return fmt;
};

/* eslint-enable */
